import React, { CSSProperties, useMemo } from 'react';
import { ColumnMeta, CellContext, ColumnDefTemplate } from '@tanstack/react-table';

import { BidElementStepsConfig, BidSheetRow } from '../../hooks/useBidSheetState';

import './RangeIndicatedCell.scss';

const defaultFormatter = (v: number | null) => v;

const RangeIndicatedCell: ColumnDefTemplate<CellContext<BidSheetRow, number | null>> = ({ column, getValue, row }) => {
  const value = getValue();
  const noValue = value === null || value === undefined;
  const formatter = (column.columnDef.meta as ColumnMeta<BidSheetRow, number | null>).formatter ?? defaultFormatter;

  const config = row.original[`${column.id}Config` as keyof BidSheetRow] as BidElementStepsConfig;

  const underlineStyle: CSSProperties | undefined = useMemo(() => {
    if (!config || config.steps?.length !== 4 || value === null || value === undefined) {
      return undefined;
    }

    return {
      backgroundColor: config.getRangeColor(value),
    };
  }, [value, config]);

  if (config !== undefined && config.steps?.length === 4) {
  }

  return (
    <span className={`enkrateia-range-indicated-cell ${noValue ? 'no-value' : ''}`}>
      <span className="inner">
        {noValue ? '-' : formatter(value)}
        {underlineStyle && <span className="underline" style={underlineStyle}></span>}
      </span>
    </span>
  );
};

export default RangeIndicatedCell;
